export default {
  api: {
    error: {
      currency: {
        notFound: "Currency not found",
      }
    }
  }
}
